function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m32.089 0.74h31.054c17.339 0 31.395 14.055 31.395 31.395v31.054c0 17.34-14.056 31.396-31.395 31.396h-31.054c-17.339 0-31.396-14.056-31.396-31.396v-31.054c0-17.34 14.057-31.395 31.396-31.395z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "65.477 65.522 47.616 72.922 29.753 65.522 22.355 47.662 29.753 29.8 47.616 22.4 65.477 29.8 72.875 47.662"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "0.693 47.832 14.344 34.865 22.192 47.832"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "0.864 28.381 14.344 34.865 29.871 29.916"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "29.7 29.746 34.819 14.731 10.59 9.271 14.344 34.865"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "47.616 22.409 34.989 14.901 27.994 0.91"
}), /*#__PURE__*/React.createElement("line", {
  x1: 47.616,
  x2: 34.989,
  y1: 0.74,
  y2: 14.901
}), /*#__PURE__*/React.createElement("polyline", {
  points: "94.538 47.832 80.887 34.865 73.04 47.832"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "94.368 28.381 80.887 34.865 65.361 29.916"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "65.532 29.746 60.413 14.731 84.641 9.271 80.887 34.865"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "47.616 22.409 60.243 14.901 67.238 0.91"
}), /*#__PURE__*/React.createElement("line", {
  x1: 47.616,
  x2: 60.243,
  y1: 0.74,
  y2: 14.901
}), /*#__PURE__*/React.createElement("polyline", {
  points: "94.538 47.491 80.887 60.458 73.04 47.491"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "94.368 66.942 80.887 60.458 65.361 65.407"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "65.532 65.577 60.413 80.592 84.641 86.054 80.887 60.458"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "47.616 72.914 60.243 80.422 67.238 94.413"
}), /*#__PURE__*/React.createElement("line", {
  x1: 47.616,
  x2: 60.243,
  y1: 94.583,
  y2: 80.422
}), /*#__PURE__*/React.createElement("polyline", {
  points: "0.693 47.491 14.344 60.458 22.192 47.491"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "0.864 66.942 14.344 60.458 29.871 65.407"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "29.7 65.577 34.819 80.592 10.59 86.054 14.344 60.458"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "47.616 72.914 34.989 80.422 27.994 94.413"
}), /*#__PURE__*/React.createElement("line", {
  x1: 47.616,
  x2: 34.989,
  y1: 94.583,
  y2: 80.422
}), /*#__PURE__*/React.createElement("path", {
  d: "m137.72 0.74h31.054c17.339 0 31.395 14.055 31.395 31.395v31.054c0 17.34-14.056 31.396-31.395 31.396h-31.054c-17.339 0-31.396-14.056-31.396-31.396v-31.054c0-17.34 14.057-31.395 31.396-31.395z"
}), /*#__PURE__*/React.createElement("polygon", {
  transform: "translate(105.63)",
  points: "65.477 29.8 72.875 47.662 65.477 65.522 47.616 72.922 29.753 65.522 22.355 47.662 29.753 29.8 47.616 22.4"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "0.693 47.832 14.344 34.865 22.192 47.832"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "0.864 28.381 14.344 34.865 29.871 29.916"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "29.7 29.746 34.819 14.731 10.59 9.271 14.344 34.865"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "47.616 22.409 34.989 14.901 27.994 0.91"
}), /*#__PURE__*/React.createElement("line", {
  x1: 153.25,
  x2: 140.62,
  y1: 0.74,
  y2: 14.901
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "94.538 47.832 80.887 34.865 73.04 47.832"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "94.368 28.381 80.887 34.865 65.361 29.916"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "65.532 29.746 60.413 14.731 84.641 9.271 80.887 34.865"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "47.616 22.409 60.243 14.901 67.238 0.91"
}), /*#__PURE__*/React.createElement("line", {
  x1: 153.25,
  x2: 165.87,
  y1: 0.74,
  y2: 14.901
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "94.538 47.491 80.887 60.458 73.04 47.491"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "94.368 66.942 80.887 60.458 65.361 65.407"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "65.532 65.577 60.413 80.592 84.641 86.054 80.887 60.458"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "47.616 72.914 60.243 80.422 67.238 94.413"
}), /*#__PURE__*/React.createElement("line", {
  x1: 153.25,
  x2: 165.87,
  y1: 94.583,
  y2: 80.422
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "0.693 47.491 14.344 60.458 22.192 47.491"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "0.864 66.942 14.344 60.458 29.871 65.407"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "29.7 65.577 34.819 80.592 10.59 86.054 14.344 60.458"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(105.63)",
  points: "47.616 72.914 34.989 80.422 27.994 94.413"
}), /*#__PURE__*/React.createElement("line", {
  x1: 153.25,
  x2: 140.62,
  y1: 94.583,
  y2: 80.422
}));

const SvgCushionPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 201,
  height: 95.334,
  enableBackground: "new 0 0 95.333 95.334",
  viewBox: "0 0 201 95.334",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCushionPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cushion-pair.bd041695.svg";
export { ForwardRef as ReactComponent };